import { useMutation } from '@tanstack/react-query'

import { updateRampCurve } from '@/features/resource/endpoints/resources'
import type { UpdateRampCurveRequest } from '@/features/resource/types'

export function useUpdateRampCurveMutation(resourceId: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: ({ rampCurveId, data }: { rampCurveId: string; data: UpdateRampCurveRequest }) =>
      updateRampCurve(resourceId, rampCurveId, data),
  })

  return {
    updateRampCurve: mutateAsync,
    ...mutationResult,
  }
}
